export const translations = {
  en: {
    // Common
    common: {
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      clearFilters: 'Clear Filters',
      email: 'Email',
      password: 'Password',
      name: 'Full Name',
      role: 'Role',
      status: 'Status',
      date: 'Date',
      price: 'Price',
      logout: 'Logout',
      viewDetails: 'View Details',
      back: 'Back',
      yes: 'Yes',
      no: 'No',
      actions: 'Actions'
    },

    // Launch Page
    launch: {
      comingSoon: 'COMING SOON',
      description: 'The platform that completely eliminates high fraud risks during the transfer process of resold digital tickets between two individuals.',
      launchDate: 'March 2026',
      launchApproaching: 'Official launch approaching',
      dontMiss: 'Don\'t miss the launch!',
      followUs: 'Follow us on social media to be informed in advance of all details and news',
      followOnFacebook: 'Follow us on Facebook',
      followOnInstagram: 'Follow us on Instagram',
      beFirst: 'Be the first to know about exclusive announcements!',
      secureTransactions: 'Secure Transfers',
      secureDesc: 'Trusted intermediary to protect buyers and sellers',
      antiFraud: 'Anti-Fraud',
      antiFraudDesc: 'Fraud prevention during ticket transfer',
      fastSimple: 'Fast & Simple',
      fastSimpleDesc: 'Smooth and secure end-to-end process',
      protectedAccess: 'Protected Access',
      inDevelopment: 'This platform is currently under development',
      accessPassword: 'Access Password',
      enterPassword: 'Enter password',
      incorrectPassword: 'Incorrect password. Please try again.',
      access: 'Access',
      verifying: 'Verifying...',
      restrictedAccess: 'Restricted access: The platform is currently in development phase. Access is reserved for authorized developers and testers only.'
    },

    // Authentication
    auth: {
      welcomeBack: 'Welcome back!',
      welcome: 'Welcome!',
      signIn: 'Sign In',
      register: 'Register',
      createAccount: 'Create Account',
      joinFree: 'Join Middleman for free',
      login: 'Login',
      getStarted: 'Get Started',
      alreadyHaveAccount: 'Already have an account?',
      dontHaveAccount: "Don't have an account?",
      signInToContinue: 'Sign in or create an account to continue',
      email: 'Email',
      password: 'Password',
      fullName: 'Full Name',
      role: 'Role',
      buyer: 'Buyer',
      seller: 'Seller',
      enterYourEmail: 'Enter your email',
      enterYourPassword: 'Enter your password',
      enterYourName: 'Enter your full name',
      emailPlaceholder: 'your.email@example.com',
      passwordPlaceholder: 'Enter your password',
      fullNamePlaceholder: 'John Doe',
      signingIn: 'Signing in...',
      loggingIn: 'Logging in...',
      creatingAccount: 'Creating account...',
      invalidCredentials: 'Invalid credentials',
      accountCreated: 'Account created successfully!',
      loginSuccess: 'Login successful!',
      forgotPassword: 'Forgot password?',
      // Registration form
      firstName: 'First Name',
      lastName: 'Last Name',
      firstNamePlaceholder: 'John',
      lastNamePlaceholder: 'Smith',
      countryOfResidence: 'Country of Residence',
      searchCountry: 'Search for a country...',
      paymentCurrency: 'Payment Currency',
      communicationLanguage: 'Communication Language',
      communicationLanguageNote: 'Notifications (emails and SMS) will be sent in this language.',
      french: 'French',
      english: 'English',
      loginEmail: 'Login Email',
      emailConfirmation: 'Email Confirmation',
      retypeEmail: 'Retype your email',
      emailsDoNotMatch: 'Emails do not match',
      passwordConfirmation: 'Password Confirmation',
      retypePassword: 'Retype your password',
      passwordsDoNotMatch: 'Passwords do not match',
      passwordRequirements: 'Password must contain:',
      minChars: '8 characters minimum',
      oneUppercase: '1 uppercase letter',
      oneLowercase: '1 lowercase letter',
      oneNumber: '1 number',
      phoneNumber: 'Phone Number',
      phoneConfirmation: 'Phone Confirmation',
      retypePhone: 'Retype your phone number',
      phonesDoNotMatch: 'Phone numbers do not match',
      communicationConsent: 'I agree to receive communications about my transactions',
      smsConsent: 'I agree to receive SMS notifications',
      interacWarning: 'This email will also be used when we send you payments by Interac e-Transfer.',
      createMyAccount: 'Create my account',
      reportProblem: 'Having trouble registering?'
    },

    // Home Page
    home: {
      title: 'Middleman',
      subtitle: 'Secure ticket exchange platform for buying and selling event tickets with confidence',
      whyChoose: 'Why Choose Middleman?',
      secureTransactions: 'Secure Transfers',
      secureTransactionsDesc: 'Your funds are secured until tickets are verified',
      verification: 'OCR + Manual Verification',
      verificationDesc: 'AI-powered OCR with human verification backup',
      fairPricing: 'Fair Pricing',
      fairPricingDesc: 'Fixed transfer fees with no hidden costs',
      trustedPlatform: 'Trusted Platform',
      trustedPlatformDesc: 'Protecting buyers and sellers since 2025'
    },

    // Dashboard
    dashboard: {
      title: 'Dashboard',
      myTransactions: 'My Transactions',
      totalTransactions: 'Total Transactions',
      buying: 'Buying',
      selling: 'Selling',
      active: 'Active',
      totalValue: 'Total Value',
      createTransaction: 'Create Transaction',
      newTransaction: 'New Transaction',
      noTransactions: 'No transactions yet',
      noTransactionsDesc: 'Create your first transaction to get started',
      noBuyingTransactions: 'No buying transactions',
      noSellingTransactions: 'No selling transactions',
      all: 'All',
      viewManage: 'View and manage all your ticket transactions. You can be a buyer or seller depending on the transaction.'
    },

    // Transaction
    transaction: {
      buyerEmail: 'Buyer Email',
      sellerEmail: 'Seller Email',
      eventName: 'Event Name',
      eventDate: 'Event Date',
      ticketCount: 'Ticket Count',
      tickets: 'ticket(s)',
      section: 'Section',
      row: 'Row',
      seats: 'Seats',
      transactionId: 'Transaction ID',
      uploadTicket: 'Upload Ticket',
      uploadTickets: 'Upload Tickets',
      ticketImage: 'Ticket Image (JPG, PNG, PDF)',
      uploading: 'Uploading...',
      uploadedTickets: 'Uploaded Tickets',
      noTickets: 'No tickets uploaded yet',
      verifyTicket: 'Verify Ticket',
      rejectTicket: 'Reject Ticket',
      verificationNotes: 'Verification Notes',
      addNotes: 'Add notes about the verification...',
      ocrStatus: 'OCR Status',
      ocrSuccess: 'OCR Success',
      adminVerified: 'Admin Verified',
      extractedInfo: 'Extracted Information',
      ocrText: 'OCR Text',
      adminNotes: 'Admin Notes',
      transactionCreated: 'Transaction created successfully!',
      ticketUploaded: 'Ticket uploaded successfully!',
      ticketVerified: 'Ticket verified successfully!',
      ticketRejected: 'Ticket rejected',
      statusCreated: 'Created',
      statusTicketsUploaded: 'Tickets Uploaded',
      statusOcrVerified: 'OCR Verified',
      statusAdminVerified: 'Admin Verified',
      statusPaymentReceived: 'Payment Received',
      statusCompleted: 'Completed',
      statusDisputed: 'Disputed',
      statusCancelled: 'Cancelled'
    },

    // Admin
    admin: {
      title: 'Admin Dashboard',
      subtitle: 'Transaction & User Management',
      totalUsers: 'Total Users',
      pendingVerification: 'Pending Verification',
      verified: 'Verified',
      allTransactions: 'All Transactions',
      manageVerify: 'Manage and verify ticket transactions',
      noTransactionsAdmin: 'No transactions yet',
      stats: 'Statistics'
    },

    // Business Dashboard
    business: {
      title: 'Business Dashboard',
      subtitle: 'Platform Analytics & Insights',
      totalRevenue: 'Total Revenue',
      platformFees: 'Platform Fees',
      monthRevenue: 'this month',
      revenueOverview: 'Revenue Overview',
      lastDays: 'Last {{days}} Days',
      platformHealth: 'Platform Health',
      successRate: 'Success Rate',
      disputeRate: 'Dispute Rate',
      avgTransaction: 'Avg Transaction',
      perTransaction: 'Per transaction value',
      userAnalytics: 'User Analytics',
      userEngagement: 'User engagement and distribution',
      activeUsers: 'Active Users',
      roleDistribution: 'Role Distribution',
      userGrowth: 'User Growth (Last 7 Days)',
      transactionAnalytics: 'Transaction Analytics',
      performance: 'Performance and status breakdown',
      statusBreakdown: 'Status Breakdown',
      ocrSuccess: 'OCR Success',
      avgProcessing: 'Avg Processing',
      quickActions: 'Quick Actions & Reports',
      exportData: 'Export data and manage platform settings',
      exportMonthly: 'Export Monthly Report',
      exportUsers: 'Export User Data',
      exportTransactions: 'Export Transactions'
    },

    // Super Admin
    superAdmin: {
      title: 'Super Admin Control Panel',
      subtitle: 'Full Platform Management',
      badge: 'SUPER ADMIN',
      overview: 'Overview',
      users: 'Users',
      transactions: 'Transactions',
      settings: 'Settings',
      addUser: 'Add User',
      addNewUser: 'Add New User',
      createUserAccount: 'Create a new user account',
      userCreated: 'User created successfully!',
      userDeleted: 'User deleted successfully',
      roleUpdated: 'User role updated!',
      userManagement: 'User Management',
      manageUsers: 'Manage all platform users and team members',
      allTransactions: 'All Transactions',
      manageTransactions: 'View and manage all platform transactions',
      platformSettings: 'Platform Settings',
      configureSettings: 'Configure system settings and preferences',
      paymentSettings: 'Payment Settings',
      configureStripe: 'Configure Stripe and payment processing',
      emailNotifications: 'Email Notifications',
      configureEmail: 'Configure email service and templates',
      ocrSettings: 'OCR Settings',
      configureOcr: 'Configure Google Vision API',
      platformFees: 'Platform Fees',
      currentFee: 'Current fee: $6.95 to $19.95 based on transfer amount',
      updateFees: 'Update Fee Structure',
      searchTransactions: 'Search by event name, buyer, or seller...',
      allStatuses: 'All Statuses',
      showHidden: 'Show Hidden',
      resetPassword: 'Reset Password',
      newPassword: 'New Password',
      transactionUpdated: 'Transfer status updated!',
      transactionHidden: 'Transfer hidden',
      transactionUnhidden: 'Transfer unhidden',
      transactionDeleted: 'Transfer deleted permanently',
      confirmDelete: 'Are you sure you want to permanently delete this transfer? This cannot be undone.',
      confirmDeleteUser: 'Are you sure you want to delete this user?',
      cannotDeleteSelf: 'Cannot delete your own account',
      hide: 'Hide',
      unhide: 'Unhide',
      hidden: 'Hidden'
    },

    // Roles
    roles: {
      buyer: 'Buyer',
      seller: 'Seller',
      admin: 'Admin',
      owner: 'Business Owner',
      super_admin: 'Super Admin'
    },

    // Notifications
    notifications: {
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Info',
      loadingData: 'Loading data...',
      failedToLoad: 'Failed to load data',
      savingChanges: 'Saving changes...',
      changesSaved: 'Changes saved successfully'
    },

    // Footer
    footer: {
      copyright: '© 2025 Middleman. Secure ticket transactions for everyone.'
    },

    // Landing Page
    landing: {
      heroTitle: 'Secure your ticket transactions',
      heroSubtitle: 'Buy and sell event tickets safely with complete peace of mind',
      startTransfer: 'Start a ticket transfer',
      aboutTitle: 'Who are we?',
      aboutP1: 'Middleman is a Canadian platform designed to secure ticket transactions between individuals. Whether it\'s for a game, a show, or a sold-out event, it has never been easier – and above all safer – to buy or sell a ticket online.',
      aboutP2: 'We know how risky it can be to trust a stranger on the Internet. That\'s why Middleman acts as an impartial trusted third party to protect you against fraud and guarantee a hassle-free transaction.',
      aboutP3: 'Middleman is peace of mind with every transaction.',
      howItWorksTitle: 'How it works',
      howItWorksSubtitle: 'A simple and secure process in 3 steps',
      step1Title: 'Create transaction',
      step1Desc: 'The seller or buyer initiates the transaction and provides ticket details',
      step2Title: 'Verification & payment',
      step2Desc: 'Seller sends tickets, we verify them, and buyer pays via secure link',
      step3Title: 'Secure delivery',
      step3Desc: 'Once verified and paid, we release the tickets to the buyer and funds to the seller',
      whyChooseTitle: 'Why choose middleman?',
      feature1Title: 'Trusted intermediary',
      feature1Desc: 'Your funds are secured until tickets are verified',
      feature2Title: 'Ticket verification',
      feature2Desc: 'AI-powered OCR with human verification.',
      feature3Title: 'Fast transaction',
      feature3Desc: 'Transfers are completed quickly.',
      feature4Title: 'Fair pricing',
      feature4Desc: 'Fixed pricing with no hidden fees',
      feature4Link: 'See pricing',
      testimonialsTitle: 'What our customers say',
      testimonialsSubtitle: 'Trusted by thousands of ticket buyers and sellers',
      testimonial1: 'I was skeptical about buying tickets online, but Middleman gave me complete peace of mind. The verification process was thorough and fast!',
      testimonial2: 'As a seller, I finally found a safe way to transfer my tickets. The secure transfer service protected me from potential fraud.',
      testimonial3: 'Best platform for ticket transfers! Simple, secure, and the customer service is excellent.',
      buyerLabel: 'Buyer',
      sellerLabel: 'Seller',
      ctaTitle: 'Ready to get started?',
      ctaSubtitle: 'Join thousands of satisfied customers who trust Middleman for their ticket transfers',
      getStartedNow: 'Get started now',
      footerTagline: 'Secure ticket transfers for everyone',
      quickLinks: 'Quick links',
      aboutUs: 'About us',
      howItWorks: 'How it works',
      faq: 'FAQ',
      contact: 'Contact',
      legal: 'Legal',
      termsOfService: 'Terms of service',
      privacyPolicy: 'Privacy policy',
      allRightsReserved: 'All rights reserved.',
      securityTitle: 'Why security matters',
      securityDesc: 'Fraud in ticket resale on social media is on the rise. Discover how Middleman protects you.',
      viewFraudStats: 'View fraud statistics',
      viewFAQ: 'View FAQ',
      protection1: 'Tickets validated before payment',
      protection2: 'No exchange of personal info',
      protection3: '100% traceable transactions'
    },

    // Navigation
    nav: {
      home: 'Home',
      howItWorks: 'How it works',
      whyUs: 'Why us',
      events: 'Events',
      faq: 'FAQ',
      contact: 'Contact',
      login: 'Login',
      createAccount: 'Create account',
      dashboard: 'Dashboard',
      settings: 'Settings',
      logout: 'Logout'
    },

    // Contact Page
    contact: {
      pageTitle: 'Support & Contact',
      pageSubtitle: 'Choose the method that suits you best',
      chatbotTitle: 'FAQ Chatbot',
      chatbotDesc: 'Get instant answers to your most frequently asked questions',
      chatbotResponse: 'Instant response',
      startChat: 'Start chat',
      messengerTitle: 'Messenger',
      messengerDesc: 'Chat with our team on Facebook Messenger',
      messengerResponse: 'Less than 1 hour',
      openMessenger: 'Open Messenger',
      ticketTitle: 'Support Ticket',
      ticketDesc: 'Create a ticket for personalized follow-up of your request',
      ticketResponse: 'Guaranteed response',
      createTicket: 'Create a ticket',
      orFillForm: 'Or fill out our contact form',
      formTitle: 'Contact Form',
      formSubtitle: 'Fill out the form below and we will get back to you as soon as possible',
      yourName: 'Your name',
      yourEmail: 'Your email',
      phone: 'Phone (optional)',
      subject: 'Subject',
      category: 'Category',
      categoryGeneral: 'General question',
      categoryTechnical: 'Technical issue',
      categoryPayment: 'Payment',
      categoryOther: 'Other',
      message: 'Your message',
      messagePlaceholder: 'Describe your request in detail...',
      send: 'Send',
      sending: 'Sending...',
      successTitle: 'Message sent!',
      successMessage: 'Thank you for contacting us. We will get back to you as soon as possible.',
      ticketNumber: 'Your ticket number:',
      newMessage: 'Send a new message',
      errorSending: 'Error sending message'
    },

    // Settings Page
    settings: {
      pageTitle: 'Settings',
      profile: 'Profile',
      security: 'Security',
      notifications: 'Notifications',
      personalInfo: 'Personal Information',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      clientNumber: 'Client number',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm new password',
      updatePassword: 'Update password',
      twoFactorAuth: '2FA Authentication',
      enable2FA: 'Enable two-factor authentication',
      disable2FA: 'Disable two-factor authentication',
      emailNotifications: 'Email notifications',
      smsNotifications: 'SMS notifications',
      marketingEmails: 'Marketing emails',
      transactionAlerts: 'Transaction alerts',
      saveChanges: 'Save changes',
      saved: 'Changes saved!',
      passwordUpdated: 'Password updated successfully'
    },

    // Transaction Page
    transaction: {
      pageTitle: 'Transaction Details',
      reference: 'Reference',
      status: 'Status',
      created: 'Created',
      event: 'Event',
      eventDate: 'Event date',
      venue: 'Venue',
      tickets: 'Tickets',
      quantity: 'Quantity',
      section: 'Section',
      row: 'Row',
      seats: 'Seats',
      pricing: 'Pricing',
      ticketPrice: 'Ticket price',
      serviceFee: 'Service fee',
      total: 'Total',
      buyer: 'Buyer',
      seller: 'Seller',
      paymentMethod: 'Payment method',
      interacInstructions: 'Interac e-Transfer Instructions',
      sendTo: 'Send to:',
      amount: 'Amount:',
      reference: 'Reference:',
      copyEmail: 'Copy email',
      copied: 'Copied!',
      wiseInstructions: 'Wise Transfer Instructions',
      confirmPayment: 'Confirm payment sent',
      timeline: 'Transaction Timeline',
      statusPending: 'Pending',
      statusConfirmed: 'Confirmed',
      statusPaymentReceived: 'Payment received',
      statusTicketsVerified: 'Tickets verified',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled'
    },

    // Events Page  
    events: {
      pageTitle: 'Upcoming Events',
      pageSubtitle: 'Find tickets for the hottest events',
      searchPlaceholder: 'Search events...',
      filterByCategory: 'Filter by category',
      allCategories: 'All categories',
      concerts: 'Concerts',
      sports: 'Sports',
      theater: 'Theater',
      festivals: 'Festivals',
      noEvents: 'No events found',
      viewDetails: 'View details',
      buyTickets: 'Buy tickets',
      sellTickets: 'Sell tickets'
    },

    // Reset Password Page
    resetPassword: {
      pageTitle: 'Reset Password',
      enterEmail: 'Enter your email address',
      emailPlaceholder: 'your.email@example.com',
      sendLink: 'Send reset link',
      sending: 'Sending...',
      checkEmail: 'Check your email',
      emailSent: 'We sent a password reset link to your email address.',
      backToLogin: 'Back to login',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      resetButton: 'Reset Password',
      resetting: 'Resetting...',
      passwordReset: 'Password reset successfully!',
      invalidToken: 'Invalid or expired reset token'
    }
  },

  fr: {
    // Commun
    common: {
      loading: 'Chargement...',
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      create: 'Créer',
      search: 'Rechercher',
      filter: 'Filtrer',
      clearFilters: 'Effacer les filtres',
      email: 'Courriel',
      password: 'Mot de passe',
      name: 'Nom complet',
      role: 'Rôle',
      status: 'Statut',
      date: 'Date',
      price: 'Prix',
      logout: 'Déconnexion',
      viewDetails: 'Voir les détails',
      back: 'Retour',
      yes: 'Oui',
      no: 'Non',
      actions: 'Actions'
    },

    // Page de Lancement
    launch: {
      comingSoon: 'LANCEMENT PRÉVU',
      description: 'La plateforme qui élimine totalement les risques élevés de fraude lors du processus de transfert de billets numériques revendus entre deux particuliers.',
      launchDate: 'Mars 2026',
      launchApproaching: 'Le lancement officiel approche',
      dontMiss: 'Ne manquez rien du lancement !',
      followUs: 'Suivez-nous sur nos réseaux sociaux pour être informé en avant-première de tous les détails et nouveautés',
      followOnFacebook: 'Suivez-nous sur Facebook',
      followOnInstagram: 'Suivez-nous sur Instagram',
      beFirst: 'Soyez les premiers informés des annonces exclusives !',
      secureTransactions: 'Transferts Sécurisés',
      secureDesc: 'Intermédiaire de confiance pour protéger acheteurs et vendeurs',
      antiFraud: 'Anti-Fraude',
      antiFraudDesc: 'Prévention de fraude lors du transfert de billets',
      fastSimple: 'Simple & Rapide',
      fastSimpleDesc: 'Processus fluide et sécurisé de bout en bout',
      protectedAccess: 'Accès Protégé',
      inDevelopment: 'Cette plateforme est actuellement en développement',
      accessPassword: 'Mot de passe d\'accès',
      enterPassword: 'Entrez le mot de passe',
      incorrectPassword: 'Mot de passe incorrect. Veuillez réessayer.',
      access: 'Accéder',
      verifying: 'Vérification...',
      restrictedAccess: 'Accès restreint : La plateforme est actuellement en phase de développement. L\'accès est réservé aux développeurs et testeurs autorisés uniquement.'
    },

    // Authentification
    auth: {
      welcomeBack: 'Bon retour!',
      welcome: 'Bienvenue!',
      signIn: 'Se connecter',
      register: 'S\'inscrire',
      createAccount: 'Créer un compte',
      joinFree: 'Rejoignez Middleman gratuitement',
      login: 'Connexion',
      getStarted: 'Commencer',
      alreadyHaveAccount: 'Vous avez déjà un compte?',
      dontHaveAccount: "Vous n'avez pas de compte?",
      signInToContinue: 'Connectez-vous ou créez un compte pour continuer',
      email: 'Courriel',
      password: 'Mot de passe',
      fullName: 'Nom complet',
      role: 'Rôle',
      buyer: 'Acheteur',
      seller: 'Vendeur',
      enterYourEmail: 'Entrez votre courriel',
      enterYourPassword: 'Entrez votre mot de passe',
      enterYourName: 'Entrez votre nom complet',
      emailPlaceholder: 'votre.courriel@exemple.com',
      passwordPlaceholder: 'Entrez votre mot de passe',
      fullNamePlaceholder: 'Jean Dupont',
      signingIn: 'Connexion en cours...',
      loggingIn: 'Connexion en cours...',
      creatingAccount: 'Création du compte...',
      invalidCredentials: 'Identifiants invalides',
      accountCreated: 'Compte créé avec succès!',
      loginSuccess: 'Connexion réussie!',
      forgotPassword: 'Mot de passe oublié?',
      // Registration form
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      firstNamePlaceholder: 'Jean',
      lastNamePlaceholder: 'Tremblay',
      countryOfResidence: 'Pays de résidence',
      searchCountry: 'Rechercher un pays...',
      paymentCurrency: 'Devise de paiement',
      communicationLanguage: 'Langue de communication',
      communicationLanguageNote: 'Les notifications (courriels et SMS) seront envoyées dans cette langue.',
      french: 'Français',
      english: 'English',
      loginEmail: 'Courriel de connexion',
      emailConfirmation: 'Confirmation du courriel',
      retypeEmail: 'Retapez votre courriel',
      emailsDoNotMatch: 'Les courriels ne correspondent pas',
      passwordConfirmation: 'Confirmation du mot de passe',
      retypePassword: 'Retapez votre mot de passe',
      passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
      passwordRequirements: 'Le mot de passe doit contenir:',
      minChars: '8 caractères minimum',
      oneUppercase: '1 majuscule',
      oneLowercase: '1 minuscule',
      oneNumber: '1 chiffre',
      phoneNumber: 'Numéro de téléphone',
      phoneConfirmation: 'Confirmation du téléphone',
      retypePhone: 'Retapez votre numéro de téléphone',
      phonesDoNotMatch: 'Les numéros de téléphone ne correspondent pas',
      communicationConsent: 'J\'accepte de recevoir des communications concernant mes transactions',
      smsConsent: 'J\'accepte de recevoir des notifications par SMS',
      interacWarning: 'Ce courriel sera aussi utilisé lorsque nous vous enverrons des paiements par virement Interac.',
      createMyAccount: 'Créer mon compte',
      reportProblem: 'Problème avec l\'inscription?'
    },

    // Page d'accueil
    home: {
      title: 'Middleman',
      subtitle: 'Middleman sécurise les transferts de billets entre particuliers',
      whyChoose: 'Pourquoi choisir Middleman?',
      secureTransactions: 'Transferts sécurisés',
      secureTransactionsDesc: 'Vos fonds sont sécurisés jusqu\'à la vérification des billets',
      verification: 'Vérification manuelle',
      verificationDesc: 'Chaque billet est vérifié par notre équipe avant le transfert',
      fairPricing: 'Prix transparent',
      fairPricingDesc: 'Frais de 6,95$ à 19,95$ selon le montant du transfert, sans coûts cachés',
      trustedPlatform: 'Plateforme de confiance',
      trustedPlatformDesc: 'Protection des deux parties depuis 2025'
    },

    // Tableau de bord
    dashboard: {
      title: 'Tableau de bord',
      myTransactions: 'Mes demandes de transfert',
      totalTransactions: 'Demandes totales',
      buying: 'Achat',
      selling: 'Vente',
      active: 'Actives',
      totalValue: 'Valeur totale',
      createTransaction: 'Nouvelle demande de transfert',
      newTransaction: 'Nouvelle demande de transfert',
      noTransactions: 'Aucune demande de transfert pour le moment',
      noTransactionsDesc: 'Créez votre première demande de transfert pour commencer',
      noBuyingTransactions: 'Aucune demande d\'achat',
      noSellingTransactions: 'Aucune demande de vente',
      all: 'Toutes',
      viewManage: 'Voir et gérer toutes vos demandes de transfert de billets. Vous pouvez être acheteur ou vendeur selon la transaction.'
    },

    // Demande de transfert
    transaction: {
      buyerEmail: 'Courriel de l\'acheteur',
      sellerEmail: 'Courriel du vendeur',
      eventName: 'Nom de l\'événement',
      eventDate: 'Date de l\'événement',
      ticketCount: 'Nombre de billets',
      tickets: 'billet(s)',
      section: 'Section',
      row: 'Rangée',
      seats: 'Sièges',
      transactionId: 'Numéro de référence',
      uploadTicket: 'Télécharger un billet',
      uploadTickets: 'Télécharger des billets',
      ticketImage: 'Image du billet (JPG, PNG, PDF)',
      uploading: 'Téléchargement...',
      uploadedTickets: 'Billets téléchargés',
      noTickets: 'Aucun billet téléchargé pour le moment',
      verifyTicket: 'Vérifier le billet',
      rejectTicket: 'Rejeter le billet',
      verificationNotes: 'Notes de vérification',
      addNotes: 'Ajouter des notes sur la vérification...',
      ocrStatus: 'Statut OCR',
      ocrSuccess: 'Succès OCR',
      adminVerified: 'Vérifié par l\'admin',
      extractedInfo: 'Informations extraites',
      ocrText: 'Texte OCR',
      adminNotes: 'Notes de l\'admin',
      transactionCreated: 'Transaction créée avec succès!',
      ticketUploaded: 'Billet téléchargé avec succès!',
      ticketVerified: 'Billet vérifié avec succès!',
      ticketRejected: 'Billet rejeté',
      statusCreated: 'Créée',
      statusTicketsUploaded: 'Billets téléchargés',
      statusOcrVerified: 'OCR vérifié',
      statusAdminVerified: 'Admin vérifié',
      statusPaymentReceived: 'Paiement reçu',
      statusCompleted: 'Complétée',
      statusDisputed: 'Contestée',
      statusCancelled: 'Annulée'
    },

    // Administrateur
    admin: {
      title: 'Tableau de bord administrateur',
      subtitle: 'Gestion des transferts et des utilisateurs',
      totalUsers: 'Utilisateurs totaux',
      pendingVerification: 'En attente de vérification',
      verified: 'Vérifiés',
      allTransactions: 'Toutes les demandes de transfert',
      manageVerify: 'Gérer et vérifier les transferts de billets',
      noTransactionsAdmin: 'Aucune demande de transfert pour le moment',
      stats: 'Statistiques'
    },

    // Tableau de bord d'affaires
    business: {
      title: 'Tableau de bord d\'affaires',
      subtitle: 'Analyses et perspectives de la plateforme',
      totalRevenue: 'Revenu total',
      platformFees: 'Frais de plateforme',
      monthRevenue: 'ce mois-ci',
      revenueOverview: 'Aperçu des revenus',
      lastDays: '{{days}} derniers jours',
      platformHealth: 'Santé de la plateforme',
      successRate: 'Taux de réussite',
      disputeRate: 'Taux de litiges',
      avgTransaction: 'Transaction moy.',
      perTransaction: 'Valeur par transfert',
      userAnalytics: 'Analytique des utilisateurs',
      userEngagement: 'Engagement et distribution des utilisateurs',
      activeUsers: 'Utilisateurs actifs',
      roleDistribution: 'Distribution des rôles',
      userGrowth: 'Croissance des utilisateurs (7 derniers jours)',
      transactionAnalytics: 'Analytique des transferts',
      performance: 'Performance et répartition des statuts',
      statusBreakdown: 'Répartition des statuts',
      ocrSuccess: 'Succès OCR',
      avgProcessing: 'Traitement moy.',
      quickActions: 'Actions rapides et rapports',
      exportData: 'Exporter les données et gérer les paramètres de la plateforme',
      exportMonthly: 'Exporter le rapport mensuel',
      exportUsers: 'Exporter les données des utilisateurs',
      exportTransactions: 'Exporter les transferts'
    },

    // Super administrateur
    superAdmin: {
      title: 'Panneau de contrôle super administrateur',
      subtitle: 'Gestion complète de la plateforme',
      badge: 'SUPER ADMIN',
      overview: 'Aperçu',
      users: 'Utilisateurs',
      transactions: 'Transactions',
      settings: 'Paramètres',
      addUser: 'Ajouter un utilisateur',
      addNewUser: 'Ajouter un nouvel utilisateur',
      createUserAccount: 'Créer un nouveau compte utilisateur',
      userCreated: 'Utilisateur créé avec succès!',
      userDeleted: 'Utilisateur supprimé avec succès',
      roleUpdated: 'Rôle de l\'utilisateur mis à jour!',
      userManagement: 'Gestion des utilisateurs',
      manageUsers: 'Gérer tous les utilisateurs de la plateforme et les membres de l\'équipe',
      allTransactions: 'Toutes les demandes de transfert',
      manageTransactions: 'Voir et gérer toutes les demandes de transfert de la plateforme',
      platformSettings: 'Paramètres de la plateforme',
      configureSettings: 'Configurer les paramètres système et les préférences',
      paymentSettings: 'Paramètres de paiement',
      configureStripe: 'Configurer Stripe et le traitement des paiements',
      emailNotifications: 'Notifications par courriel',
      configureEmail: 'Configurer le service de courriel et les modèles',
      ocrSettings: 'Paramètres OCR',
      configureOcr: 'Configurer Google Vision API',
      platformFees: 'Frais de plateforme',
      currentFee: 'Frais actuel: 6,95$ à 19,95$ selon le montant',
      updateFees: 'Mettre à jour la structure des frais',
      searchTransactions: 'Rechercher par nom d\'événement, acheteur ou vendeur...',
      allStatuses: 'Tous les statuts',
      showHidden: 'Afficher masqués',
      resetPassword: 'Réinitialiser le mot de passe',
      newPassword: 'Nouveau mot de passe',
      transactionUpdated: 'Statut du transfert mis à jour!',
      transactionHidden: 'Transaction masquée',
      transactionUnhidden: 'Transaction affichée',
      transactionDeleted: 'Transaction supprimée définitivement',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer définitivement ce transfert? Cette action est irréversible.',
      confirmDeleteUser: 'Êtes-vous sûr de vouloir supprimer cet utilisateur?',
      cannotDeleteSelf: 'Impossible de supprimer votre propre compte',
      hide: 'Masquer',
      unhide: 'Afficher',
      hidden: 'Masqué'
    },

    // Rôles
    roles: {
      buyer: 'Acheteur',
      seller: 'Vendeur',
      admin: 'Administrateur',
      owner: 'Propriétaire d\'entreprise',
      super_admin: 'Super administrateur'
    },

    // Notifications
    notifications: {
      success: 'Succès',
      error: 'Erreur',
      warning: 'Avertissement',
      info: 'Info',
      loadingData: 'Chargement des données...',
      failedToLoad: 'Échec du chargement des données',
      savingChanges: 'Enregistrement des modifications...',
      changesSaved: 'Modifications enregistrées avec succès'
    },

    // Pied de page
    footer: {
      copyright: '© 2025 Middleman. Transactions de billets sécurisées pour tous.'
    },

    // Landing Page
    landing: {
      heroTitle: 'Sécurisez vos transferts de billets',
      heroSubtitle: 'Achetez et vendez des billets d\'événements en toute sécurité et en toute tranquillité',
      startTransfer: 'Débuter un transfert de billets',
      aboutTitle: 'Qui sommes-nous?',
      aboutP1: 'Middleman est une plateforme québécoise conçue pour sécuriser les transferts de billets entre particuliers. Que ce soit pour un match, un spectacle ou un événement à guichets fermés, il n\'a jamais été aussi simple – et surtout sécuritaire – d\'acheter ou vendre un billet en ligne.',
      aboutP2: 'Nous savons à quel point il peut être risqué de faire confiance à un inconnu sur Internet. C\'est pourquoi Middleman agit comme tiers de confiance impartial, pour vous protéger contre les fraudes et garantir un transfert sans tracas.',
      aboutP3: 'Middleman, c\'est la paix d\'esprit à chaque transaction.',
      howItWorksTitle: 'Comment ça fonctionne',
      howItWorksSubtitle: 'Un processus simple et sécurisé en 3 étapes',
      step1Title: 'Créer une demande de transfert',
      step1Desc: 'Le vendeur ou l\'acheteur initie la demande de transfert et fournit les détails du billet',
      step2Title: 'Vérification et paiement',
      step2Desc: 'Le vendeur envoie les billets, nous les vérifions, et l\'acheteur paie via lien sécurisé',
      step3Title: 'Livraison sécurisée',
      step3Desc: 'Une fois vérifié et payé, nous libérons les billets à l\'acheteur et les fonds au vendeur',
      whyChooseTitle: 'Pourquoi choisir middleman?',
      feature1Title: 'Intermédiaire de confiance',
      feature1Desc: 'Vos fonds sont sécurisés jusqu\'à ce que les billets soient vérifiés',
      feature2Title: 'Vérification des billets',
      feature2Desc: 'OCR alimenté par IA avec vérification humaine.',
      feature3Title: 'Transaction rapide',
      feature3Desc: 'Les transferts sont complétés rapidement.',
      feature4Title: 'Prix équitable',
      feature4Desc: 'Tarification fixe sans frais cachés',
      feature4Link: 'Voir les tarifs',
      testimonialsTitle: 'Ce que disent nos clients',
      testimonialsSubtitle: 'Faites confiance à des milliers d\'acheteurs et vendeurs de billets',
      testimonial1: 'J\'étais sceptique à propos de l\'achat de billets en ligne, mais Middleman m\'a donné une tranquillité d\'esprit totale. Le processus de vérification était minutieux et rapide!',
      testimonial2: 'En tant que vendeur, j\'ai enfin trouvé un moyen sûr de transférer mes billets. Le transfert sécurisé m\'a protégé contre la fraude potentielle.',
      testimonial3: 'Meilleure plateforme pour les transferts de billets! Simple, sécurisée, et le service client est excellent.',
      buyerLabel: 'Acheteur',
      sellerLabel: 'Vendeur',
      ctaTitle: 'Prêt à commencer?',
      ctaSubtitle: 'Rejoignez des milliers de clients satisfaits qui font confiance à Middleman pour leurs transferts de billets',
      getStartedNow: 'Commencer maintenant',
      footerTagline: 'Transferts de billets sécurisés pour tous',
      quickLinks: 'Liens rapides',
      aboutUs: 'À propos',
      howItWorks: 'Comment ça fonctionne',
      faq: 'FAQ',
      contact: 'Contact',
      legal: 'Juridique',
      termsOfService: 'Conditions d\'utilisation',
      privacyPolicy: 'Politique de confidentialité',
      allRightsReserved: 'Tous droits réservés.',
      securityTitle: 'Pourquoi la sécurité compte',
      securityDesc: 'Les fraudes dans la revente de billets sur les réseaux sociaux sont en hausse. Découvrez comment Middleman vous protège.',
      viewFraudStats: 'Voir les statistiques de fraude',
      viewFAQ: 'Consulter la FAQ',
      protection1: 'Billets validés avant paiement',
      protection2: 'Aucun échange de coordonnées',
      protection3: 'Transactions 100% traçables'
    },

    // Navigation
    nav: {
      home: 'Accueil',
      howItWorks: 'Comment ça fonctionne',
      whyUs: 'Pourquoi nous',
      events: 'Événements',
      faq: 'FAQ',
      contact: 'Contact',
      login: 'Connexion',
      createAccount: 'Créer un compte',
      dashboard: 'Tableau de bord',
      settings: 'Paramètres',
      logout: 'Déconnexion'
    },

    // Page Contact
    contact: {
      pageTitle: 'Support & Contact',
      pageSubtitle: 'Choisissez le moyen qui vous convient le mieux',
      chatbotTitle: 'Chatbot FAQ',
      chatbotDesc: 'Obtenez des réponses instantanées à vos questions les plus fréquentes',
      chatbotResponse: 'Réponse immédiate',
      startChat: 'Démarrer le chat',
      messengerTitle: 'Messenger',
      messengerDesc: 'Discutez avec notre équipe sur Facebook Messenger',
      messengerResponse: 'Moins de 1 heure',
      openMessenger: 'Ouvrir Messenger',
      ticketTitle: 'Ticket de support',
      ticketDesc: 'Créez un ticket pour un suivi personnalisé de votre demande',
      ticketResponse: 'Réponse garantie',
      createTicket: 'Créer un ticket',
      orFillForm: 'Ou remplissez notre formulaire de contact',
      formTitle: 'Formulaire de contact',
      formSubtitle: 'Remplissez le formulaire ci-dessous et nous vous répondrons dans les plus brefs délais',
      yourName: 'Votre nom',
      yourEmail: 'Votre courriel',
      phone: 'Téléphone (optionnel)',
      subject: 'Sujet',
      category: 'Catégorie',
      categoryGeneral: 'Question générale',
      categoryTechnical: 'Problème technique',
      categoryPayment: 'Paiement',
      categoryOther: 'Autre',
      message: 'Votre message',
      messagePlaceholder: 'Décrivez votre demande en détail...',
      send: 'Envoyer',
      sending: 'Envoi en cours...',
      successTitle: 'Message envoyé!',
      successMessage: 'Merci de nous avoir contactés. Nous vous répondrons dans les plus brefs délais.',
      ticketNumber: 'Votre numéro de ticket:',
      newMessage: 'Envoyer un nouveau message',
      errorSending: 'Erreur lors de l\'envoi du message'
    },

    // Page Paramètres
    settings: {
      pageTitle: 'Paramètres',
      profile: 'Profil',
      security: 'Sécurité',
      notifications: 'Notifications',
      personalInfo: 'Informations personnelles',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Courriel',
      phone: 'Téléphone',
      clientNumber: 'Numéro de client',
      changePassword: 'Changer le mot de passe',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le nouveau mot de passe',
      updatePassword: 'Mettre à jour le mot de passe',
      twoFactorAuth: 'Authentification 2FA',
      enable2FA: 'Activer l\'authentification à deux facteurs',
      disable2FA: 'Désactiver l\'authentification à deux facteurs',
      emailNotifications: 'Notifications par courriel',
      smsNotifications: 'Notifications SMS',
      marketingEmails: 'Courriels marketing',
      transactionAlerts: 'Alertes de transaction',
      saveChanges: 'Enregistrer les modifications',
      saved: 'Modifications enregistrées!',
      passwordUpdated: 'Mot de passe mis à jour avec succès'
    },

    // Page Transaction
    transaction: {
      pageTitle: 'Détails de la transaction',
      reference: 'Référence',
      status: 'Statut',
      created: 'Créée le',
      event: 'Événement',
      eventDate: 'Date de l\'événement',
      venue: 'Lieu',
      tickets: 'Billets',
      quantity: 'Quantité',
      section: 'Section',
      row: 'Rangée',
      seats: 'Sièges',
      pricing: 'Tarification',
      ticketPrice: 'Prix des billets',
      serviceFee: 'Frais de service',
      total: 'Total',
      buyer: 'Acheteur',
      seller: 'Vendeur',
      paymentMethod: 'Mode de paiement',
      interacInstructions: 'Instructions de virement Interac',
      sendTo: 'Envoyer à:',
      amount: 'Montant:',
      copyEmail: 'Copier le courriel',
      copied: 'Copié!',
      wiseInstructions: 'Instructions de transfert Wise',
      confirmPayment: 'Confirmer le paiement envoyé',
      timeline: 'Historique de la transaction',
      statusPending: 'En attente',
      statusConfirmed: 'Confirmée',
      statusPaymentReceived: 'Paiement reçu',
      statusTicketsVerified: 'Billets vérifiés',
      statusCompleted: 'Complétée',
      statusCancelled: 'Annulée'
    },

    // Page Événements
    events: {
      pageTitle: 'Événements à venir',
      pageSubtitle: 'Trouvez des billets pour les événements les plus populaires',
      searchPlaceholder: 'Rechercher des événements...',
      filterByCategory: 'Filtrer par catégorie',
      allCategories: 'Toutes les catégories',
      concerts: 'Concerts',
      sports: 'Sports',
      theater: 'Théâtre',
      festivals: 'Festivals',
      noEvents: 'Aucun événement trouvé',
      viewDetails: 'Voir les détails',
      buyTickets: 'Acheter des billets',
      sellTickets: 'Vendre des billets'
    },

    // Page Réinitialisation mot de passe
    resetPassword: {
      pageTitle: 'Réinitialiser le mot de passe',
      enterEmail: 'Entrez votre adresse courriel',
      emailPlaceholder: 'votre.courriel@exemple.com',
      sendLink: 'Envoyer le lien de réinitialisation',
      sending: 'Envoi en cours...',
      checkEmail: 'Vérifiez votre courriel',
      emailSent: 'Nous avons envoyé un lien de réinitialisation de mot de passe à votre adresse courriel.',
      backToLogin: 'Retour à la connexion',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      resetButton: 'Réinitialiser le mot de passe',
      resetting: 'Réinitialisation...',
      passwordReset: 'Mot de passe réinitialisé avec succès!',
      invalidToken: 'Jeton de réinitialisation invalide ou expiré'
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key;
    }
  }
  
  return value || key;
};